import { CompleteServiceExecutionFragment } from 'drycut-graphql';
import EmptyState from '../EmptyState';
import OnHoldServiceRow from './OnHoldServiceRow';
import QueueTable from '../QueueTable';

type Props = {
  services: CompleteServiceExecutionFragment[];
};

export default function OnHoldServicesTable({ services }: Props): React.ReactElement {
  if (services.length === 0) return <EmptyState>Keine No Shows vorhanden.</EmptyState>;

  return (
    <QueueTable.Table>
      <QueueTable.TableHeader>
        <QueueTable.THead>Buchung</QueueTable.THead>
        <QueueTable.THead>Kunde</QueueTable.THead>
        <QueueTable.THead />
      </QueueTable.TableHeader>

      <tbody>
        {services.map((serviceExecution) => (
          <OnHoldServiceRow key={serviceExecution.id} serviceExecution={serviceExecution} />
        ))}
      </tbody>
    </QueueTable.Table>
  );
}
